import React from "react";
import styled, { keyframes } from "styled-components";
import * as colors from "../../assets/_base/colors"
// Animação giratória para o spinner
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Componente do spinner estilizado
const Spinner = styled.div`
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-top: 5px solid ${colors.primary}; /* Altere a cor conforme desejar */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${rotate} 1s linear infinite;
`;

// Componente do contêiner que centraliza o spinner
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loading = () => {
  return (
    <LoadingContainer>
      <Spinner />
    </LoadingContainer>
  );
};

export default Loading


// WEBPACK FOOTER //
// ./src/_components/Loading/index.jsx